import { connect } from 'react-redux';
import {
    switchGrowthAnalysisPeriod,
    switchPmPeriod,
} from '../../../api/periods/shared/periodsActions';
import ProgressHeader from '../../../features/progress/shared/ProgressHeader';
import { selectors } from '../../../root/reading/root';
import { openBasicComprehensionWebEntry } from '../../../api/basicComprehensionWebEntry/shared/basicComprehensionWebEntryActions';
import { TITLE } from '../../../constants/shared/PMConstants';
import { GA } from '../../../constants/shared/CommonConstants';
import { basicComprehensionGradesMap } from '../../../constants/shared/GradesConstants';

const mapStateToProps = (state, { progressTab }) => {
    const classGrades = selectors.getGradesInCurrentClass(state);
    const isDemoModeOn = selectors.getIsDemoModeOn(state);
    const gradeToMeasureMapper = selectors.getGradeToMeasureMapper(state);
    const { GRADES_WITH_BC } = basicComprehensionGradesMap(gradeToMeasureMapper);

    return {
        showAddNew:
            GRADES_WITH_BC.some(grade => classGrades.includes(grade)) &&
            progressTab === TITLE.PM_TITLE,
        GA,
        isDemoModeOn,
    };
};

const mapDispatchToProps = dispatch => ({
    openBasicComprehensionWebEntry: () => dispatch(openBasicComprehensionWebEntry(false)),
    switchPmPeriod: (period, subtabTitle) => {
        dispatch(switchPmPeriod(period, subtabTitle));
    },
    switchGrowthAnalysisPeriod: (period, subtabTitle) => {
        dispatch(switchGrowthAnalysisPeriod(period, subtabTitle));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressHeader);
